module.exports = __webpack_public_path__ + "img/support.a994a8f0.svg";